import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81b77c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 left-0 w-full h-full z-50"
}
const _hoisted_3 = { class: "my-auto text-lg font-medium" }
const _hoisted_4 = { class: "flex flex-col space-y-1" }
const _hoisted_5 = { class: "my-auto text-lg font-medium" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex my-auto relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full z-50" }, null, -1))
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "my-auto text-lg font-medium" }

import {computed, onMounted, PropType, ref, watch} from "vue";
import {IonCheckbox, IonToggle} from "@ionic/vue";

export interface InputCheckboxOption {
  text: string,
  value: string | boolean | number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCheckbox',
  props: {
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: Array,
    required: false
  },
  inputType: {
    type: String,
    default: 'checkbox'
  },
  returnSingleValue: {
    type: Boolean,
    default: false
  },
  option: {
    type: Object as PropType<any>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  fieldClasses: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {


const props = __props

const loading = ref(true)

const emits = __emit
const model: any = ref([])

onMounted(() => {
  if (props.modelValue) model.value = props.modelValue
  loading.value = false
})

watch(() => props.modelValue, value => {
  if (value) model.value = value
})

const checkValue = () => {

  const index = model.value.indexOf(props.option.value);

  if (props.returnSingleValue) {
    model.value.splice(index, model.value.length)
  }

  if (model.value.includes(props.option.value)) return model.value.splice(index, 1)
  model.value.push(props.option.value)

}


const isChecked = computed(() => {
  return model.value.includes(props.option.value)
})

const toggleChanged = async (ev: any) => {
  emits('update:modelValue', [ev.detail.checked])
}


return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (['pill'].includes(__props.inputType))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: checkValue,
              class: _normalizeClass([[
          isChecked.value ? 'bg-brand-lime text-brand-dark-gray' : 'bg-brand-dark-gray text-white',
            __props.fieldClasses
          ], "flex justify-between p-4 py-2 rounded-full"])
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(__props.option.text), 1)
            ], 2))
          : _createCommentVNode("", true),
        (['checkbox'].includes(__props.inputType))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: checkValue,
              class: _normalizeClass([[
          isChecked.value ? 'bg-brand-lime text-brand-dark-gray' : 'bg-brand-dark-gray text-white',
          __props.fieldClasses
       ], "flex justify-between p-4 rounded-2xl"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.option.text), 1),
                (__props.option.description)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([{
               'text-brand-light-gray' : !isChecked.value,
               'text-brand-black text-opacity-70' : isChecked.value
            }, "my-auto text-base font-normal leading-tight pr-5"]),
                      innerHTML: __props.option.description
                    }, null, 10, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_unref(IonCheckbox), {
                  mode: "ios",
                  checked: isChecked.value
                }, null, 8, ["checked"])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (['toggle'].includes(__props.inputType))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([[
            __props.fieldClasses
        ], "flex justify-between bg-brand-dark-gray text-white p-4 rounded-2xl"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "start"),
                _createElementVNode("div", _hoisted_10, _toDisplayString(__props.option.text), 1)
              ]),
              _createVNode(_unref(IonToggle), {
                mode: "ios",
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (toggleChanged($event))),
                checked: isChecked.value
              }, null, 8, ["checked"])
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})